import { Component, Input } from '@angular/core';
import { Invoice } from 'src/app/shared/models/invoice.interface';

@Component({
  selector: 'app-ctn-invoice',
  templateUrl: './ctn-invoice.component.html',
  styleUrls: ['./ctn-invoice.component.scss']
})
export class CtnInvoiceComponent {
  @Input() invoices: Invoice[] = [];
  @Input() viewMode: string = 'individual';

  constructor() { }

  formatDate(dateString: string | null): string {
    if (!dateString) return '-';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-';
    return date.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    }).toUpperCase();
  }

  formatCurrency(amount: number | null, currency: string | null = 'USD'): string {
    if (!amount || amount === 0) return '-';
    const curr = currency || 'USD';
    return `${curr} ${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}
